import Vue from 'vue';
import router from '../router';
import { Route } from 'vue-router';
import { UNIT_MAIN_PAYCHECK_LINE_TEMPLATES } from '@/queries/MainPaycheckLineTemplate';
import Popup from '@/components/UI/Popup/Popup';
import i18n from '@/i18n';

const unitPaycheckLineTemplateRequiredGuard = (
  to: Route,
  from: Route,
  next: (to?: string | false | void | ((vm: Vue) => void)) => void,
): void => {
  const loader = router.app.$sLoader({
    show: true,
    fullPage: true,
    element: router.app.$el as HTMLElement,
  });

  router.app.$apollo
    .query({
      query: UNIT_MAIN_PAYCHECK_LINE_TEMPLATES,
    })
    .then(({ data }) => {
      if (!data.currentUnit.mainPaycheckLineTemplates.length) {
        next(false);
        router.push(
          { name: 'UnitMainPaycheckLineTemplates' },
          () => Popup.alert(i18n.t('Company.Setting.setCompanyPaycheckLineTemplate'), {
            title: i18n.t('Company.Setting.setCompanyPaycheckLineTemplateTitle'),
            withCloseButton: false,
            buttons: [ { text: 'OK', color: 'success', click: () => { } } ],
          }),
        );
      } else {
        next();
      }
    }).finally(() => {
      loader.show = false;
    });
};

export default unitPaycheckLineTemplateRequiredGuard;
